// extracted by mini-css-extract-plugin
export default {"back-button":"qS8b3t","backButton":"qS8b3t","buttonIcon":"JZEw8I","step-title":"ssjFoh","stepTitle":"ssjFoh","font-upgrade":"IniFL2","fontUpgrade":"IniFL2","hidden":"hbItr2"};